import { ref } from 'vue';
import type { AuthStatus, CodeResponse } from '@common/types/auth';
import { Lengths, EMPTY_DIGITS } from '@common/types/auth';

export const useAuth = () => {
  const currentStep = ref(0);
  const isLoading = ref(false);
  const phone = ref('');
  const authStatus = ref<AuthStatus>(null);

  const handlePhoneSubmit = async (phoneNumber: string) => {
    try {
      isLoading.value = true;
      phone.value = phoneNumber;
      await new Promise(resolve => setTimeout(resolve, 1000)); // Запрос на отправку кода
      currentStep.value = 1;
    }
    catch {
      authStatus.value = 'error';
    }
    finally {
      isLoading.value = false;
    }
  };

  const handleCodeSubmit = async (_code: string) => {
    try {
      isLoading.value = true;
      const res = await new Promise<CodeResponse>(resolve => setTimeout(() => resolve({ success: true }), 1000)); // Запрос на проверку кода

      if (res?.error || !res?.success) {
        throw new Error(res?.error || 'Неверный код');
      }

      authStatus.value = 'success';
      currentStep.value = 2;
    }
    catch {
      authStatus.value = 'error';
    }
    finally {
      isLoading.value = false;
    }
  };

  const handleBack = () => {
    currentStep.value -= 1;
    authStatus.value = null;
  };

  const handleRetry = () => {
    currentStep.value = 0;
    authStatus.value = null;
    phone.value = '';
  };

  const formatPhone = (phoneNumber: string) => {
    if (!phoneNumber) return '';

    let result = '+7';
    result += ` (${phoneNumber.slice(1, 4)}`;
    result += `) ${phoneNumber.slice(4, 7)}`;
    result += `-${phoneNumber.slice(7, 9)}`;
    result += `-${phoneNumber.slice(9, 11)}`;

    return result;
  };

  const isPhoneLengthValid = (phoneNumber: string) => {
    const digits = phoneNumber.replace(/\D/g, '');
    return digits.length === Lengths.PHONE;
  };

  const isCodeLengthValid = (code: string) => (code.length === Lengths.CODE);

  return {
    currentStep,
    isLoading,
    phone,
    authStatus,
    handlePhoneSubmit,
    handleCodeSubmit,
    handleBack,
    handleRetry,
    formatPhone,
    isPhoneLengthValid,
    isCodeLengthValid,
  };
};
